import { CompanyFeatures } from "v2/domain/common/enums/CompanyFeatures";
import authClient from "../../../../../app/auth/Auth";
import { apiInstance } from "../../api/apiClient";
import restoreCompanyFeatures from "../../builders/restoreCompanyFeatures";

export interface GetCompanyFeaturesResponseCardConfig {
  canManageCardRequestConfiguration: boolean;
  canSetIssueCard: boolean;
  requestModels: string[];
}

export interface GetCompanyFeaturesResponseConfig {
  cards: GetCompanyFeaturesResponseCardConfig;
}

export interface GetCompanyFeaturesResponseContent {
  features: CompanyFeatures[];
  config: GetCompanyFeaturesResponseConfig;
}

export interface GetCompanyFeaturesResponse {
  content: GetCompanyFeaturesResponseContent;
}

const getUrl = ({ companyId }: { companyId: string }) =>
  `/companies/v1/companies/${companyId}/features`;

const getCompanyFeatures = async () => {
  const companyId = await authClient.getCompanyId();
  const url = getUrl({ companyId: companyId ?? "" });

  const { data } = await apiInstance.get<GetCompanyFeaturesResponse>(url, {});

  return restoreCompanyFeatures({ content: data.content.features });
};

export default getCompanyFeatures;
